import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

/**
 * Shared by every piece of template UI that needs to know how the open version relates to the published
 * ones. Using a single query document means Apollo serves them all from one cache entry, so a refetch after
 * publishing or withdrawing updates all of them at once.
 *
 * The button fragment drives the publish controls. `publishedAt` is selected inline rather than added to
 * that fragment because template exports are its only consumer, and it merges into the same records.
 */
export const TEMPLATE_PUBLISHING_RECORDS_QUERY = gql`
  query TemplatePublishingRecordsQuery($templateId: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    template(id: $templateId) {
      ... on TemplateNode {
        id
        ...PublishingRecordsForButtonGraphQL
        publishingRecords {
          ... on PublishingRecordNode {
            id
            publishedAt
          }
          ...InaccessibleInfoGraphQL
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('PublishingRecordsForButton').fragment}
`;
